import React, { useEffect, useState, useCallback, useMemo } from "react";

import { useAuth } from "../../../hooks/auth";
import apiV2 from "../../../services/apiV2";

import { Category as CategoryInterface } from "../../../models/AuthModels";

import CategoryContainer from "../../../components/Mols/CategoryContainer";
import MainSlider from "../../../components/Mols/MainSlider";
import MainSliderSkeleton from "../../../components/Mols/Shimmer/MainSlider";

import { Container } from "./styles";

const Cursos: React.FC = () => {
  const [categories, setCategories] = useState<CategoryInterface[]>([]);
  const [slideImgs, setSlideImgs] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);

  const { user, getDashboard } = useAuth();

  let urlAtual =
    process.env.NODE_ENV === "development"
      ? `${process.env.REACT_APP_WHITELABEL}`
      : window.location.href;
  let splitUrlProd = urlAtual.split(".");
  let subdomain = splitUrlProd[0].includes("www")
    ? ["", splitUrlProd[1]]
    : splitUrlProd[0].split("//");

  const getAllCategories = useCallback(async () => {
    setIsLoading(true);

    const response = await apiV2.get(
      `/course?userid=${user.userid}&schoolid=${user.schoolid}`
    );

    setCategories(response.data.courses);
    setSlideImgs(response.data.banners);
    setIsLoading(false);
  }, [user.userid]);

  useEffect(() => {
    getAllCategories();
    getDashboard(user);
  }, [getAllCategories, user, getDashboard]);

  /**
   * "Continue assistindo" — derivada NO CLIENTE sobre a resposta que já foi
   * baixada. Nenhuma chamada de API nova, nenhuma mudança no que o backend
   * devolve: é só uma leitura diferente dos mesmos cursos.
   *
   * Um curso entra quando é do aluno e está começado mas não terminado. Como
   * o mesmo curso pode aparecer em mais de uma categoria, `seen` garante uma
   * entrada por `courseid`.
   *
   * Só existe com 2+ cursos qualificados: com um só, a fileira empurra o
   * catálogo para baixo sem pagar o espaço que ocupa. Repetir o curso na
   * categoria de origem é esperado — todo serviço de streaming faz isso.
   */
  const continueWatching = useMemo(() => {
    const seen = new Set<string>();
    const qualifying: any[] = [];

    categories.forEach((category) => {
      (category.courses || []).forEach((course: any) => {
        if (!course || seen.has(course.courseid)) return;

        const progress = Number(course.userprogress) || 0;

        if (course.is_owner && progress > 0 && progress < 1) {
          seen.add(course.courseid);
          qualifying.push(course);
        }
      });
    });

    return qualifying.sort(
      (a, b) => (Number(b.userprogress) || 0) - (Number(a.userprogress) || 0)
    );
  }, [categories]);

  const visibleCategories = useMemo<CategoryInterface[]>(() => {
    if (continueWatching.length < 2) return categories;

    return [
      {
        id: "continue-assistindo",
        title: "Continue assistindo",
        position: -1,
        type: "horizontal",
        courses: continueWatching,
      },
      ...categories,
    ];
  }, [categories, continueWatching]);

  return (
    <Container>
      {slideImgs.length > 0 ? (
        <MainSlider slideImgs={slideImgs} />
      ) : (
        <MainSliderSkeleton />
      )}
      <CategoryContainer categories={visibleCategories} isLoading={isLoading} />
    </Container>
  );
};

export default Cursos;
